export const licensePlateValidation = (plate: string): boolean => {
  const normalizedPlate = plate.replace(/[^A-Z0-9]/g, '').toUpperCase();
  const platePattern = /^[A-Z]{3}\d[0-9A-J]\d{2}$/;
  return platePattern.test(normalizedPlate);
};
